enum UserRoles {
  Developer = "DEVELOPER",
  Tester = "TESTER",
  Manager = "MANAGER",
  RequirementsAnalyst = "REQUIREMENTS_ANALYST",
  Administrative = "ADMINISTRATIVE",
  Technician = "TECHNICIAN",
}

export default UserRoles;
